export default {
  chatContacts: state => state.chatContacts,
  chatContactInfos: state => state.chatContactInfos,
  selectedCustomerChats: state => state.selectedCustomerChats,
  isSocketAlreadyListened: state => state.isSocketAlreadyListened,
  transferredChats: state => state.transferredChats,
  customersToRemoveIds: state => state.customersToRemoveIds,
  inboxMessagesStatus: state => state.inboxMessagesStatus,
  chatTab: state => state.chatTab,
  chatFilter: state => state.chatFilter,
  additionalChatFilter: state => state.additionalChatFilter,
  chatContactDropdown: state => state.chatContactDropdown,
  attendancePopupIsActive: state => state.attendancePopupIsActive,
  chatPickingPopup: state => state.chatPickingPopup,
  pickingPopupIsActive: state => state.pickingPopupIsActive,
  chatFinalizePopup: state => state.chatFinalizePopup,
  finalizePopupIsActive: state => state.finalizePopupIsActive,
  chatTransferPopup: state => state.chatTransferPopup,
  transferPopupIsActive: state => state.transferPopupIsActive,
  groupsSelectedFilter: state => state.groupsSelectedFilter
}
